import { hexToRgb } from './hexToRgb';

export const getCellStyles = (percent: number, color: string) => {
  const rgbColor = hexToRgb(color);
  return {
    backgroundColor: `rgba(${rgbColor}, ${percent})`,
    color: percent >= 0.8 ? 'white' : 'black',
  };
};
